<template>
    <div class="notification-list-wrapper bg-white" :class="{'d-block d-lg-none': showNotificationList, 'd-none': !showNotificationList}">
        <div class="bg-primary-darkest text-white py-4 position-fixed notification-list-header">
            <div class="container">
                <div class="row">
                    <div class="col-3 text-start">
                        <div @click="hideNotificationList">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="nav-icon"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path></svg>
                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <h2 class="text-base fw-bold">
                            {{ $t('Dine varsler') }}
                        </h2>
                    </div>
                    <div class="col-3">

                    </div>
                </div>
            </div>
        </div>

        <div class="row h-100 align-content-center" v-show="!loaded">
            <div class="text-center col-12 pt-2">
                <span class="spinner-border" role="status"></span>
            </div>
        </div>
        <div v-if="loaded">
            <div class="px-3 py-3 border-top border-secondary notification-wrapper" v-for="notification in notifications" :class="{'bg-unread': notificationUnread(notification)}">
                <div class="row">
                    <div class="col-8 text-notification-header-color">
                        <div class="px-1 d-inline">
                            <svg xmlns="http://www.w3.org/2000/svg" class="notification-icon" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" :d="notificationIcon(notification)" clip-rule="evenodd" />
                            </svg>
                        </div>
                        <small class="text-xs">
                            {{ notificationType(notification) }}
                        </small>
                    </div>
                    <div class="col-4 text-end text-notification-header-color">
                        <div class="mr-2">
                            <small class="text-xs">{{ notification.formattedNotificationDate }}</small>
                        </div>
                    </div>
                    <div class="offset-1 col-10 text-notification-body-color">
                        <small v-html="notification.message"></small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import Api from '../../api/Notification';

const props = defineProps(['showNotificationList']);
const emit = defineEmits(['hide']);

const notifications = ref([]);
const loaded = ref(false);
const lastLoaded = ref(null);

watch(() => props.showNotificationList, () => {
    const shouldReload = ((Date.now() - lastLoaded.value) / 1000) > 180;
    if (props.showNotificationList && (!loaded.value || shouldReload)) {
        Api.Get().then(res => {
            loaded.value = true;
            notifications.value = res.data.notifications;
        });
        lastLoaded.value = Date.now();
        setTimeout(() => {
            markAsRead();
        }, 5000);
    }
});

const markAsRead = () => {
    notifications.value = notifications.value.map(notification => {
        notification.read = 1;
        return notification;
    });
};

const hideNotificationList = () => {
    emit('hide');
};

const notificationType = (notification) => {
    if (notification.message.indexOf('kansellert') > -1) {
        return $t('Booking');
    }
    switch(notification.message_type) {
        case 'message_log':
            return $t('Opplæring');
        case 'notification':
        default:
            return $t('Varsel');
    }
};

const notificationIcon = (notification) => {
    switch(notificationType(notification)) {
        case 'Booking':
            return 'M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z';
        case 'Opplæring':
        default:
            return 'M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z';
    }
};

const notificationUnread = (notification) => {
    return notification.read === '0000-00-00 00:00:00';
};
</script>

<style scoped>
    .notification-list-wrapper {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1082;

        padding-top: 64px;
        display: block;
        overflow-y: auto;
    }
    .notification-list-header {
        top:0;
        left:0;
        right: 0;
        z-index: 1083;
    }
    .notification-icon {
        width: 16px;
        height: 15px;
    }
    .bg-unread {
        background-color: #EAF2FE;
    }
    .text-notification-header-color {
        color: #51617A;
    }
    .text-notification-body-color {
        color: #1C2B43;
    }
    .notification-wrapper {
        transition: all 300ms;
    }
</style>